module.exports = {"id":"235164","name":"Luca Mora","rating":"71","photo":"./data/images/photos/2/235164.png","club":{"name":"La Spezia","logo":"./data/images/clubs/LaSpezia.png"},"positions":["MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LucaMora0.json
// module id = 2554
// module chunks = 0